export default __webpack_public_path__ + "static/media/icona-calavera.7f367079.svg";